<template>
  <a
    class="product-map-link-wrapper nolink"
    :href="mapLink"
    target="_blank"
    onclick="window.ym(42050389,'reachGoal','go_to_map')"
  >
    <ng-sheet class="product-map-link fill-height" :bg-src="backgroundImage">
      <ng-sheet class="product-map-link__inner" xs>
        <h4 class="mb-1">
          <v-icon color="primary" class="mr-1">mdi-open-in-new</v-icon>
          <span class="vcenter">{{ $t('product.demoMapTitle') }}</span>
        </h4>
        <div class="body-2 text-muted">
          {{ $t('product.demoMapDescription') }}
        </div>
      </ng-sheet>
    </ng-sheet>
  </a>
</template>

<script>
export default {
  name: 'ProductMapLink',
  props: {
    mapLink: {
      type: String,
    },
    backgroundImage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.product-map-link {
  display: flex;

  &__inner {
    align-self: end;
    border: 2px solid transparent;
    transition: border-color 0.2s;

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
      max-width: 90%;
    }
  }
}

.product-map-link-wrapper {
  &:hover {
    .product-map-link {
      &__inner {
        border-color: var(--v-primary-base);
      }
    }
  }
}
</style>
